const dns_template = {
	dialog_add_template: {
		description:
			"Fügen Sie hier eine neue DNS-Vorlage hinzu. Nachdem Sie sie hinzugefügt haben, können Sie die Vorlage ausfüllen.",
		input_description: {
			label: "Beschreibung DNS-Vorlage",
			placeholder: "Optional kann die Vorlage beschrieben werden",
		},
		input_name: {
			label: "Name der DNS-Vorlage",
			placeholder: "Zum Beispiel 'template-webserver'",
		},
		messages: {
			success: "Die DNS-Vorlage <strong>{{name}}</strong> wurde erfolgreich erstellt!",
		},
		title: "DNS-Vorlage hinzufügen",
	},
	dialog_delete_template: {
		description:
			"Sind Sie sicher, dass Sie die Vorlage <strong>{{name}}</strong> entfernen möchten?",
		messages: {
			success: "Die DNS-Vorlage <strong>{{name}}</strong> wurde erfolgreich gelöscht!",
		},
		title: "DNS-Vorlage löschen",
	},

	/* -------------------------------------------------------------------------- */
	/*                                  DNS TABLE                                 */
	/* -------------------------------------------------------------------------- */
	dns_table: {},

	/* -------------------------------------------------------------------------- */
	/*                        DNS TEMPLATE MANAGEMENT PAGE                        */
	/* -------------------------------------------------------------------------- */
	management: {
		buttons: {
			add_record: "Zeile hinzufügen",
			choose_template: "Vorlagendatensätze auswählen",
			remove_default: "Vorlage ist als Standard eingestellt",
			retrieve_dns: "DNS-Einträge abrufen",
			set_as_default: "Als Standard eingestellt",
		},
		form: {
			description: "Beschreibung",
			name: "Name",
		},
		information:
			"Mit DNS-Vorlagen können Sie auf einfache Weise DNS-Einträge für Ihre Domains erstellen. Sie können diese Vorlagen verwenden, wenn Sie eine neue Domain erstellen oder DNS-Einträge für bestehende Domain verwalten.",
		messages: {
			set_as_default_selected: "DNS-Einträge als Standard aktiviert",
			set_as_default_unselected: "DNS-Einträge standardmäßig deaktiviert",
			success: "Die DNS-Vorlage <strong>{{name}}</strong> wurde erfolgreich geändert!",
		},
		sure_to_leave:
			"Sind Sie sicher, dass Sie die Seite verlassen wollen?\nNicht gespeicherte Änderungen gehen verloren.",
		tooltips: {
			choose_template:
				"Mit dieser Schaltfläche können Sie DNS-Einträge aus einer Ihrer anderen DNS-Vorlagen auswählen, um sie der Liste der aktuellen DNS-Einträge hinzuzufügen.",
			retrieve_dns:
				"Mit dieser Schaltfläche können Sie DNS-Einträge von einem vorhandenen Domänennamen abrufen und auswählen, welche DNS-Einträge importiert und in der Liste der aktuellen DNS-Einträge verwendet werden sollen.",
			set_as_default:
				"Mit dieser Schaltfläche können Sie die aktuelle DNS-Vorlage als Standard festlegen. Das bedeutet, dass diese Vorlage bei der Erstellung einer neuen Domain automatisch ausgewählt wird, was nützlich ist, wenn Sie bei der Erstellung einer Domain häufig diese Vorlage wählen.",
		},
	},
	/* -------------------------------------------------------------------------- */
	/*                                OVERVIEW PAGE                               */
	/* -------------------------------------------------------------------------- */
	overview: {
		table: {
			default: "Standard",
			description: "Beschreibung",
			label: "Etikett",
		},
		title: "DNS-Vorlagen",
	},
};

export default dns_template;
